//ABOUT page component
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react';
import {graphql, Link} from 'gatsby';
import GoogleFontLoader from 'react-google-font-loader';
//COMPONENT DEPENDENCIES
import Heading from '../components/heading';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import PageHeader from '../components/PageHeader';
import FullWidthImage from '../components/FullWidthImage';
import TextBlock from '../components/textblock';
import ContentBlock from '../components/ContentBlock';
import Header from '../components/Header';
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************        
const aboutPage = ({data}) => {
    
    const about = data.about.edges
    
    return (
        
        <div>
            
             <Helmet>
                   <title>NJCCIC About Page</title>
                    <meta name="description" content="The NJCCIC works to make New Jersey more resilient to cyberattacks by promoting statewide awareness of cyber threats and widespread adoption of best practices"/>
            </Helmet>
        
            <Heading/>
            
            <Navbar/>
        
            {about.map(({ node: {page_title, header_image, header_image_alt_text, introductory_text, subheader_a, text_a, icon_a, content_group, subheader_b, text_b, icon_b, icon_c, subheader_c, text_c, text_d} }) => (
        
                <div class="container-fluid">
    
                    <PageHeader divClass="background" elementClass="pageHeader centerText" title={page_title}/>  
                    
                    <div class="container containerWidth">
                        
                        <div class="row">
		
							<Header divClass="col-12 headerPadding" title="Our Mission" styles="header contentTitle titleAlt pad"/>
        
                            <TextBlock elementClass="standardText introPadding" text={introductory_text}/>
                            
                        </div>
                        
                    </div>
                    <img class="icon headerIcon" src={icon_a} alt="Services icon"/>
                    
                    <div class="container containerWidth">
                        
                        <div class="row">
                            
                            <Header divClass="col-12 headerPadding" title={subheader_a} styles="header contentTitle titleAlt"/>
                            
                        </div>
                        
                    </div>                  
                    
                    <ContentBlock testClass="testClass container containerWidth" elementClass="col-12 col-md-4 blocks block2 block2Alt" dangerousClass="standardText blockText margin" headerStyles="header contentTitle" data={content_group} iconId="iconsGroup"/>
                    
                    <img class="icon headerIcon" src={icon_b} alt="Cybersecurity Icon"/>
                    
                    <div class="container containerWidth">
                        
                        <div class="row">
        
                            <Header divClass="col-12 headerPadding" title={subheader_b} styles="header contentTitle titleAlt"/>
                            
                            <TextBlock elementClass="standardText" text={text_b}/>
                            
                        </div>
                        
                    </div>
                    
                    <div class="container containerWidth introPadding">
                        
                        <div class="row">
        
                            <Header divClass="col-12 headerPadding" title={subheader_c} styles="header contentTitle titleAlt"/>
		
							<div class="col-xl-6">
                            
                            	<TextBlock elementClass="standardText" text={text_c}/>
		
							</div>
		
							<div class="col-xl-6">
                            
                            	<TextBlock elementClass="standardText" text={text_d}/>
		
							</div>
                            
                        </div>
                        
                    </div>
                    
                    <FullWidthImage src={header_image} alt={header_image_alt_text}/>
                    
                </div> 
        
            ))}

            <Footer/>  
        </div>

    )
    
}
//*******************************************************************
//*******************************************************************
export const query = graphql`
    query {
        about: allButterPage(filter: {slug: { eq: "about" } }) {
            edges {
                node {
                    slug
                    seo_title
                    page_title 
                    header_image
                    header_image_alt_text
                    introductory_text
                    accent_image
                    accent_image_alt_text
                    subheader_a
                    text_a
                    content_group {
                        icon
                        section_name
                        text
						icon_alt_text
                    }
                    subheader_b
                    text_b
                    icon_a
                    icon_b
					icon_c
					subheader_c
					text_c
					text_d
                }
            }
        }
    }
`
export default aboutPage
//*******************************************************************
//*******************************************************************